import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';

dayjs.locale('zh-cn');

// 中资环品牌主题：红色为主题色（点缀使用），深色侧边栏保留
const themeConfig = {
  token: {
    colorPrimary: '#c7000b',
    colorLink: '#c7000b',
    colorLinkHover: '#e21f2c',
    colorInfo: '#c7000b',
    borderRadius: 6,
  },
  components: {
    Menu: {
      darkItemSelectedBg: '#c7000b',
      darkItemSelectedColor: '#ffffff',
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// 单文件构建（file:// 打开）用 HashRouter，线上部署用 BrowserRouter
const Router = process.env.REACT_APP_SINGLE_FILE === 'true' ? HashRouter : BrowserRouter;

root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={themeConfig}>
      <Router>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Router>
    </ConfigProvider>
  </React.StrictMode>
);
